import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { TemperaturesModel } from "./temperatures.model";

export  class DeptTemperaturesResponse extends GlobalResponseObject {
    data?: TemperaturesModel[];

     /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data
     */
      

    constructor(status: boolean, errorCode: number, internalMessage: string, data?: TemperaturesModel[]){
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}